import React, { Component } from 'react';
import * as Common from '../../helpers/Common';
import * as Config from '../../config/Config';
import * as User from '../../helpers/User';
import Reply  from './Reply';
import Inbox  from './Inbox';
const $= window.$;

class Getinbox extends Component {
  constructor(props) {
    super(props);
        this.state={
            reply_component : <Inbox  Replydata={this.getReplydata.bind(this)}/>,
        };

  }

  getUnread(new_in){
    this.props.Newunread(new_in);
  }

  getReplydata(msg_id,from,subject,content,alldata){
      this.setState({
       reply_component : <Reply msgid={msg_id} to_address={from} to_subject={subject} to_content={content} to_datas={alldata} Rerender={this.getRerender.bind(this)}/>
      })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      reply_component : <Inbox  Replydata={this.getReplydata.bind(this)}/>,
    })
  }

  getRerender(){
    this.setState({
      reply_component : <Inbox  Replydata={this.getReplydata.bind(this)}/>,
    })
  }


    render() {
      return (
        <div>
          {this.state.reply_component}
        </div>
      );
    }
}

export default Getinbox;



// WEBPACK FOOTER //
// ./src/personal_interactions/messages/Getinbox.js